import { DIM_COLOR } from "@/components/DimensionBar";

// Seven-dimension Glimpse map: neutral bars, no evaluative labels or numbers.
export const GlimpseMap = ({ dimensions }) => (
  <div data-testid="glimpse-map">
    <div className="flex items-center justify-between mb-2">
      <p className="cg-eyebrow">Authority Glimpse · seven dimensions</p>
    </div>
    <p className="text-xs text-[#6B7280] mb-4">Each bar reflects your answers to three statements. Longer or shorter bars are not better or worse.</p>
    {dimensions.map((d) => (
      <div key={d.key} className="py-3 border-b border-[var(--cg-border)] last:border-0" data-testid={`glimpse-dim-${d.key}`}>
        <p className="text-sm text-[#F3F4F6] font-medium mb-2 flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: DIM_COLOR[d.key] || "#D9A25F" }} />{d.name}
        </p>
        <div className="h-2.5 rounded-full bg-[#222634] overflow-hidden">
          <div className="h-full rounded-full transition-all duration-700"
            style={{ width: `${Math.max(4, (d.mean / 5) * 100)}%`, backgroundColor: DIM_COLOR[d.key] || "#D9A25F" }} />
        </div>
        <p className="mt-2 text-sm text-[#B9BDC7] leading-relaxed" data-testid={`glimpse-interp-${d.key}`}>
          {d.interpretation || <span className="italic text-[#6B7280]">Interpretation wording pending approval.</span>}
        </p>
      </div>
    ))}
  </div>
);
